// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jl0LT","top":"styles_top__1ay_O"};